import clsx from 'clsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const Logo = ({ className }: { className?: string }) => {
  return (
    <LazyLoadImage
      height="42"
      width="131"
      effect="opacity"
      className={clsx('h-[42px] w-[131px]', className)}
      alt="logo"
      src="/logo.svg"
    />
  );
};
